import { setIsOpen } from './set-is-open';

export const actions = {
	setIsOpen,
} as const;
